import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

const CrewInsertion = () => {
  const [entry, setEntry] = useState([]);
  const [allData, setAllData] = useState([]);
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  useEffect(() => {
    const filedData = [
      keys.reduce((acc, key, index) => {
        if (key === "CR_DATE") {
          acc[key] = entry[index] || new Date().toISOString().slice(0, 10);
        } else if (key === "inserted_by") {
          acc[key] = entry[index] || 3;
        } else {
          acc[key] = entry[index] || "";
        }
        return acc;
      }, {}),
    ];
    setAllData(filedData);
  }, [entry]);
  const keys = [
    "CR_DATE",
    "CR_DEMANDED",
    "CR_GIVEN",
    "CR_UTILIZED",
    "CR_WASTED",
    "LOCO_DEMANDED",
    "LOCO_GIVEN",
    "LOCO_WASTED",
    "REMARKS",
    "inserted_by",
  ];

  const handleChange = (keyIndex, value) => {
    const newEntry = [...entry];
    newEntry[keyIndex] = value;
    setEntry(newEntry);
  };

  const handleClear = () => {
    setEntry([]);
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(`${urlBlockPrefix}insertCrewDemanded`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(allData),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${result.status}`);
      }
      toast.success("success");
    } catch (error) {
      const updateOutput = {
        status: "failed",
        message: "Failed to update ",
      };
      toast.error("Error submitting data:", updateOutput);
    }

    handleClear();
  };
  return (
    <div className="papaDiv">
      <h5 className="bg-dark text-white text-center">
        Insert Data in Crew Demand
      </h5>
      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 ">
          <thead className="table-dark text-center align-middle">
            <tr>
              {keys.map((key, i) =>
                key === "inserted_by" ? null : (
                  <th key={i} style={{ minWidth: "90px" }}>
                    {key.replace(/_/g, " ")}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              {keys.map((key, index) =>
                key === "inserted_by" ? null : (
                  <td key={index}>
                    {key === "CR_DATE" ? (
                      <input
                        type="date"
                        className="form-control"
                        style={{ width: "160px", fontSize: "0.8rem" }}
                        value={
                          entry[index] || new Date().toISOString().slice(0, 10)
                        }
                        onChange={(e) => handleChange(index, e.target.value)}
                      />
                    ) : key === "REMARKS" ? (
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "160px", fontSize: "0.8rem" }}
                        value={entry[index] || ""}
                        onChange={(e) => handleChange(index, e.target.value)}
                      />
                    ) : (
                      <input
                        type="number"
                        className="form-control"
                        style={{
                          height: "26px",
                          padding: "2px 6px",
                          fontSize: "0.8rem",
                        }}
                        value={entry[index] || ""}
                        onChange={(e) => handleChange(index, e.target.value)}
                      />
                    )}
                  </td>
                )
              )}
            </tr>
          </tbody>
        </table>
      </div>

      <div className="text-center mt-4">
        <button
          className="btn btn-outline-danger m-2 px-5"
          onClick={handleClear}
        >
          Clear
        </button>
        <button
          className="btn btn-outline-success m-2 px-5"
          onClick={handleSubmit}
        >
          Upload
        </button>
      </div>
    </div>
  );
};

export default CrewInsertion;
